import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faArrowLeft } from "@fortawesome/free-solid-svg-icons";

function PDFViewer({ isOpen, onClose, documentUrl }) {
  if (!isOpen) return null;

  const isPdf = (() => {
    try {
      const url = new URL(documentUrl);
      return url.pathname.toLowerCase().endsWith('.pdf');
    } catch {
      return documentUrl.toLowerCase().endsWith('.pdf');
    }
  })();
  

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
      <div className="bg-white w-full max-w-5xl h-[92vh] rounded-lg shadow-xl flex flex-col">
        {/* Header */}
        <div className="flex justify-between items-center p-4 border-b">
          <div className="flex items-center space-x-4">
            <button
              onClick={onClose}
              className="text-gray-600 hover:text-gray-800 transition-colors"
            >
              <FontAwesomeIcon icon={faArrowLeft} className="text-lg" />
            </button>
            <h3 className="text-lg font-semibold">Document Viewer</h3>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-500"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        {/* PDF Viewer */}
        {isPdf ? 
        (
          <div className="flex-1 p-4">
            <iframe
              src={`${documentUrl}#toolbar=0`}
              className="w-full h-full rounded border"
              title="PDF Viewer"
            />
          </div>
        ) : (
          <div className="flex-1 p-4 flex justify-center">
            <div className="w-[800px] h-[600px] border rounded overflow-hidden">
              <img
                src={documentUrl}
                alt="Preview"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default PDFViewer;
